module.exports = __webpack_public_path__ + "media/images/application/template/icon--download-e906c5d12643198627ba75256902feb1.svg";